/**
 * Shared selection store for package page Room Selectors.
 * Overview (and steps later) subscribe; rooms set/clear by section.id.
 */
(function () {
  if (window.EuroPackageState) return;

  var state = {};
  var listeners = [];

  function notify() {
    listeners.forEach(function (fn) {
      try {
        fn(state);
      } catch (err) {
        console.error(err);
      }
    });
  }

  window.EuroPackageState = {
    get: function (sectionId) {
      if (sectionId == null) return Object.assign({}, state);
      return state[sectionId] || null;
    },

    set: function (sectionId, payload) {
      if (!sectionId) return;
      state[sectionId] = Object.assign({}, payload, { sectionId: sectionId });
      notify();
    },

    clear: function (sectionId) {
      if (sectionId == null) {
        state = {};
      } else if (state[sectionId]) {
        delete state[sectionId];
      } else {
        return;
      }
      notify();
    },

    subscribe: function (fn) {
      if (typeof fn !== 'function') return function () {};
      listeners.push(fn);
      return function unsubscribe() {
        listeners = listeners.filter(function (item) {
          return item !== fn;
        });
      };
    },

    keys: function () {
      return Object.keys(state);
    },
  };
})();
